import {EventType1} from "../../../utils2/maps";
import {RepeatType} from "../../../utils2";
import {useLocation, useNavigate} from "react-router-dom";

export function buildEventSteps(uid, did, path, advPlayback, location, navigate, type1, pathId, stpIdx) {

    if (type1 === EventType1.Automation) {
        const steps = [location.pathname, `/device/${uid}/${did}/time/${pathId}`, `/device/${uid}/${did}/${path}/${pathId}`, ...(advPlayback ? [`/device/${uid}/${did}/adv/${pathId}`] : [])]
        // const steps = [location.pathname, `/device/${uid}/${did}/time/${pathId}`, `/device/${uid}/${did}/${path}/${pathId}`]
        navigate(steps[stpIdx], {
            state: {
                steps: steps,
                currentStep: stpIdx,
                // event_type2: configure.event_type2
            }
        })
    } else if (type1 === EventType1.ControlledBy) {
        const steps = [location.pathname, `/device/${uid}/${did}/cntr/${pathId}`, `/device/${uid}/${did}/${path}/${pathId}`]
        navigate(steps[stpIdx], {
            state: {
                steps: steps,
                currentStep: stpIdx,
            }
        })
    } else if (type1 === "ALWAYS") {
        const steps = [location.pathname, `/device/${uid}/${did}/${path}/${pathId}`, ...(advPlayback ? [`/device/${uid}/${did}/adv/${pathId}`] : [])]
        // const steps = [location.pathname, `/device/${uid}/${did}/${path}/${pathId}`]
        navigate(steps[stpIdx], {
            state: {
                steps: steps,
                currentStep: stpIdx,
                name: "ALWAYS", // Use hardcoded name to recognize that is a always
                auto: {repeat: RepeatType.Always, time_start: 0, time_stop: 10079, daily: ["monday"], weekly_start: "", weekly_stop: ""},
            }
        })
    }
}